const TYPES = {
    GET_PAYOUT: 'GET_PAYOUT',
    GET_PAYOUT_COMPLETE: 'GET_PAYOUT_COMPLETE',
    GET_PAYOUT_FAILED: 'GET_PAYOUT_FAILED',

    UPDATE_SETTINGS: 'UPDATE_SETTINGS',
    UPDATE_SETTINGS_COMPLETE: 'UPDATE_SETTINGS_COMPLETE',
    UPDATE_SETTINGS_FAILED: 'UPDATE_SETTINGS_FAILED'
};

export default {
    TYPES,

    getPayout: () => ({
        type: TYPES.GET_PAYOUT
    }),

    getPayoutSuccess: (payload?) => ({
        type: TYPES.GET_PAYOUT_COMPLETE,
        payload
    }),

    getPayoutFailed: error => ({
        type: TYPES.GET_PAYOUT_FAILED,
        payload: error
    }),

    updateSettings: (payload?) => ({
        type: TYPES.UPDATE_SETTINGS,
        payload
    }),

    updateSettingsSuccess: (payload?) => ({
        type: TYPES.UPDATE_SETTINGS_COMPLETE,
        payload
    }),

    updateSettingsFailed: error => ({
        type: TYPES.UPDATE_SETTINGS_FAILED,
        payload: {error}
    })
};
